import axios from "axios"

export const ListSelection_fn = (e, ListSelection) => {
    console.log(e, ListSelection)
    if (ListSelection === "Active" && e.expiredtimestamp === 0 && e.cancelflag === 0) {
        return e
    }
    if (ListSelection === "Cancelled" && e.cancelflag !== 0) {
        return e
    }
    if (ListSelection === "Deleted" && e.expiredtimestamp !== 0) {
        return e
    }
    if (ListSelection === "All") {
        return e
    }
}

export const ListSelection_fnForMasters = (e, ListSelection) => {
    console.log(e, ListSelection)
    if (ListSelection === "Active" && (e.is_active === 1 || e.Is_Active===1) ) {
        return e
    }
    if (ListSelection === "InActive" && (e.is_active === 0 || e.Is_Active===0)) {
        return e
    }
    if (ListSelection === "All") {
        return e
    }
}